import {
  SET_ACTIVE_FACILITY
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_ACTIVE_FACILITY:
      return action.payload;

    default:
      return state;
  }
}